import { SendOutlined } from '@ant-design/icons'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { CAMPAIGN_EMPLOYEE_URL } from '@utils/urls'
import { Button, Tooltip } from 'antd'
import { FC, useState } from 'react'

interface Props {
  campaignEmployeeId: string
}

export const SendEmail: FC<Props> = ({ campaignEmployeeId }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)

  return (
    <Tooltip title="Renvoyer l'email">
      <Button
        onClick={() => {
          setIsLoading(true)
          SBAPI.Post(
            `${CAMPAIGN_EMPLOYEE_URL}/${campaignEmployeeId}/send-email`
          ).finally(() => setIsLoading(false))
        }}
        loading={isLoading}
        icon={<SendOutlined />}
      />
    </Tooltip>
  )
}

export type SendEmailType = { SendEmail: typeof SendEmail }
